import reducer from "./Reducers/index"
import { configureStore } from '@reduxjs/toolkit'

export default configureStore({
  reducer: reducer
})